import { render } from "./AddSlider.vue?vue&type=template&id=ce7b6916"
import script from "../js/add-slider.js?vue&type=script&lang=js"
export * from "../js/add-slider.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__